export default __webpack_public_path__ + "static/media/invoice.3f7603b9.png";